import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const MentionsLegales = () => (
            <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        MENTIONS LEGALES
      </Typography>

      <Divider className="cgu-divider" />

      <Typography paragraph>
        Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique, il est précisé aux utilisateurs du site www.cooptaleo.com l’identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Éditeur du site :
      </Typography>
      <Typography paragraph>
        CIT MENA INFORMATION TECHNOLOGY CONSULTANCY<br/>
        LLC au capital social de 30 000 AED<br/>
        Siège social : Office F1 – 261 Hor Al Anz – Dubai – United Arab Emirates<br/>
        Main License No. : 1422254<br/>
        Company Registration No. : 2426887<br/>
        Contact : contact@cooptaleo.com
      </Typography>

      <Typography variant="h6" gutterBottom>
        Hébergement :
      </Typography>
      <Typography paragraph>
        OVH – 2 rue Kellermann – 59100 Roubaix – France<br/>
        www.ovh.com
      </Typography>

      <Typography variant="h6" gutterBottom>
        Conception et développement :
      </Typography>
      <Typography paragraph>
        Cooptaleo : contact@cooptaleo.com
      </Typography>

      <Typography variant="h6" gutterBottom>
        Crédits photos et illustrations :
      </Typography>
      <Typography paragraph>
        Banques d’images libres de droits ou créations internes.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Conditions d'utilisation :
      </Typography>
      <Typography paragraph>
        L’utilisation du site www.cooptaleo.com  implique l’acceptation pleine et entière des conditions générales d’utilisation décrites dans les CGU.
      </Typography>
    </Box>
  </Container>
     <Footer />

  </>
);

export default MentionsLegales;
